export default "__VITE_ASSET__CyNkY7uk__"